import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'safeDate'
})
export class SafeDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(value: string | Date | null | undefined, format: string = 'MM/dd/yyyy'): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    // Check if it's a valid date
    if (!isNaN(date.getTime())) {
      return this.datePipe.transform(date, format);
    }

    return value as string;
  }
}